import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from 'js-cookie';
import { getCookie, getBaseUrl, getCloudfront, parseTwinupCookie } from '../../envUtils';

const glbModelCache = new Map(); // key: <key-unique-string>, value: {glb, thumbnail}


const getBuildingUriGlb = (buildingId, buildingUriGlb, buildingUriThumbnail) => {
    const parseS3Url = require('parse-aws-s3-url');

    // Parse GLB S3 URL → serve via CloudFront (same pattern as Scenes.js)
    const parts = parseS3Url(buildingUriGlb);
    const key = parts.Key;
    const cloudfrontBase = getCloudfront();
    const glb_path = `${cloudfrontBase}/${key}`;

    // Parse thumbnail S3 URL → serve via CloudFront
    let thumbnail_path = '';
    if (buildingUriThumbnail && buildingUriThumbnail !== '') {
        const tp = parseS3Url(buildingUriThumbnail);
        thumbnail_path = `${cloudfrontBase}/${tp.Key}`;
    }

    console.log(`🔗 getBuildingUriGlb [${buildingId}]`);
    console.log(`   CloudFront base : ${cloudfrontBase}`);
    console.log(`   S3 glblocation  : ${buildingUriGlb}`);
    console.log(`   → GLB URL       : ${glb_path}`);
    console.log(`   → Thumbnail URL : ${thumbnail_path || '(none)'}`);

    const modelObj = { glb: glb_path, thumbnail: thumbnail_path };

    // Cache by original S3 key so the same model isn't resolved twice
    const cacheKey = `${key}|${thumbnail_path}`;
    glbModelCache.set(cacheKey, modelObj);

    return Promise.resolve(modelObj);
};


function drag(ev) {
    const modelBeingDragged = ev.target.children[0]['data-value'];
    ev.dataTransfer.setData('text', JSON.parse(modelBeingDragged)['uri_glb']);
}

const taskItems = (taskList, modelUploadingInProcess) => {
    const taskItems = taskList.map((task, index) => (
        <div
            key={task.building_id}
            title={task.name}
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 'calc(50% - 10px)',
                cursor: 'pointer'
            }}
            className="item"
            data-value="1"
        >
            {task.local_glb_uri && (
                <model-viewer
                    ondragstart={() => {
                        drag(event);
                    }}
                    style={{
                        border: '2px solid rgb(243 111 75 / 56%)',
                        background: '#5c5a5a 50% / cover no-repeat',
                        width: '100px',
                        height: '100px',
                        cursor: 'pointer',
                        marginLeft: '0',
                        marginRight: '0'
                    }}
                    src={task.local_glb_uri}
                    data-original-poster={
                        task.local_thumbnail_uri ? task.local_thumbnail_uri : 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png'
                    }
                    poster={`${
                        task.local_thumbnail_uri ? task.local_thumbnail_uri : 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png'
                    }`}
                    reveal="manual"
                    data-value={JSON.stringify(task)}
                    onLoad={() => {
                        console.log(`✅ model-viewer loaded: ${task.name} → ${task.local_glb_uri}`);
                    }}
                    onError={(ev) => {
                        console.error(`❌ model-viewer error: ${task.name}`, ev.detail?.sourceError || ev);
                        console.error(`   GLB URL attempted: ${task.local_glb_uri}`);
                    }}
                    onMouseOver={(ev) => {
                        if (
                            ev.target.poster !== 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png' &&
                            ev.target.poster !== 'https://dtuas2sql0dg4.cloudfront.net/build/clickToDrop.png'
                        ) {
                            ev.target.poster = 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png';
                        }
                    }}
                    onMouseLeave={(ev) => {
                        if (ev.target.poster === 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png') {
                            ev.target.poster = ev.target.getAttribute('data-original-poster');
                        }
                        // ev.target.poster = 'https://dtuas2sql0dg4.cloudfront.net/build/hoverToLoad.png';
                    }}
                    onClick={(ev) => {
                        if (ev.target.poster === 'https://dtuas2sql0dg4.cloudfront.net/build/clickToLoad.png') {
                            ev.target.poster = 'https://dtuas2sql0dg4.cloudfront.net/build/clickToDrop.png';
                            ev.target.dismissPoster();
                        } else {
                            const dataValue = JSON.parse(ev.target.getAttribute('data-value'));
                            window.taskToUse = ev.target.getAttribute('data-value');
                            if (window.applyGlobeSpinEvent) {
                                window.applyGlobeSpinEvent();
                            }
                            viewer.clock.onTick.removeEventListener(window.applyGlobeSpin);
                            try {
                                window.selectedBuildingId = dataValue.building_id;
                                window.dropNamedAsset(dataValue.local_glb_uri);
                            } catch (err) {
                                console.error('Failed to drop asset');
                            }
                        }
                    }}
                >
                    <div class="annotation"></div>
                </model-viewer>
            )}
            {task.local_glb_uri && (
                <div style={{
                    color: '#fff',
                    fontSize: '10px',
                    textAlign: 'center',
                    marginTop: '4px',
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    padding: '0 2px'
                }}>
                    {task.name}
                </div>
            )}
            {!task.local_glb_uri && (
                <div
                    style={{
                        width: '75px',
                        height: '120px',
                        border: '2px solid rgb(243 111 75 / 56%)',
                        background: '#5c5a5a 50% / cover no-repeat',
                        // borderRadius: '10px',
                        display: 'grid',
                        placeContent: 'center',
                        marginLeft: '5px',
                        marginRight: '5px'
                    }}
                >
                    <CircularProgress />
                </div>
            )}
        </div>
    ));
    if (modelUploadingInProcess) {
        taskItems.push(
            <div
                key={Math.ceil(Math.random() * 100000)}
                style={{ display: 'grid', placeItems: 'center', width: '80px' }}
                className="item"
                data-value="1"
            >
                <div
                    style={{
                        width: '75px',
                        height: '120px',
                        border: '2px solid rgb(243 111 75 / 56%)',
                        background: '#5c5a5a 50% / cover no-repeat',
                        // borderRadius: '10px',
                        display: 'grid',
                        placeContent: 'center',
                        marginLeft: '5px',
                        marginRight: '5px'
                    }}
                >
                    <CircularProgress />
                </div>
            </div>
        );
    }
    return taskItems;
};

function Tasks(props) {
    const { modelUploaded, modelUploadingInProcess } = props;
    const [taskList, setTaskList] = React.useState([]);

    React.useEffect(() => {
        const twinupCookie = Cookies.get(getCookie());
        const cookieData = parseTwinupCookie(twinupCookie);
        if (!cookieData.access_token) {
            console.warn('Tasks: no auth cookie/access token available, skipping task list fetch.');
            return;
        }

        setTimeout(async () => {
            try {
                // Fetch all buildings via GraphQL
                const graphqlRes = await fetch(`${getBaseUrl()}/sim`, {
                    method: 'POST',
                    headers: {
                        'authorization': `Bearer ${cookieData.access_token}`,
                        'content-type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        query: 'query Query { Building { id glblocation name twinprovider thumbnaillocation } }'
                    })
                });
                const graphqlData = await graphqlRes.json();
                console.log('✅ Tasks: GraphQL Buildings response received');

                if (!graphqlData.data?.Building?.length) {
                    console.warn('⚠️  Tasks: No buildings found in GraphQL response');
                    return;
                }

                // Only show models that were uploaded locally (twinprovider === 'local')
                // and have a valid glblocation S3 URL
                const localBuildings = graphqlData.data.Building.filter(
                    (b) => b.twinprovider === 'local' && b.glblocation
                );
                console.log(`📦 Tasks: ${localBuildings.length} local buildings found (out of ${graphqlData.data.Building.length} total)`);

                const taskMap = {};

                for (const building of localBuildings) {
                    try {
                        const glbUri = await getBuildingUriGlb(building.id, building.glblocation, building.thumbnaillocation);
                        taskMap[building.id] = {
                            building_id:        building.id,
                            name:               building.name,
                            local_glb_uri:      glbUri.glb,
                            local_thumbnail_uri: glbUri.thumbnail
                        };
                        // Update the list progressively as each model resolves
                        const currTaskList = Object.values(taskMap);
                        console.log(`  ✓ Tasks: resolved GLB for "${building.name}" → setTaskList(${currTaskList.length} items)`);
                        setTaskList(currTaskList);
                        window.twinWorldTaskList = currTaskList;
                    } catch (err) {
                        console.error(`  ✗ Tasks: failed to resolve GLB for building "${building.id}":`, err.message);
                    }
                }
            } catch (err) {
                console.error('❌ Tasks: failed to fetch buildings from GraphQL:', err.message);
            }
        }, 3000);

        // eslint-disable-next-line
    }, [modelUploaded]);

    return (
        <Box sx={{ maxWidth: 1200, flexGrow: 1 }}>
            {console.log(`🎨 Tasks render: taskList has ${taskList.length} items`)}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    gap: '16px',
                    padding: '8px 12px 12px 12px',
                    flexWrap: 'wrap'
                }}
            >
                {taskItems(taskList, modelUploadingInProcess)}
            </div>
        </Box>
    );
}

Tasks.propTypes = {
    modelUploaded: PropTypes.bool,
    modelUploadingInProcess: PropTypes.bool
};

export default Tasks;
